import { css } from '@emotion/react';
import { theme } from '../../../../domain/theme';
import { contentPackageSmallStyle } from './contentPackageSmallStyle';

export const contentPackageMediumStyle = bgColor => {
  const smallStyle = contentPackageSmallStyle(bgColor);

  return {
    container: smallStyle.container,
    image: {
      container: smallStyle.image.container,
      picture: smallStyle.image.picture,
      cta: smallStyle.image.cta
    },
    text: {
      container: smallStyle.text.container,
      sponsored: smallStyle.text.sponsored,
      taxonomy: smallStyle.text.taxonomy,
      title: [
        smallStyle.text.title,
        css`
          ${theme.mq.tablet} {
            font-size: 1.47rem;
            letter-spacing: 0.1px;
            line-height: 2.25rem;
            -webkit-line-clamp: 4;
          }
          ${theme.mq.small_desktop} {
            -webkit-line-clamp: 2;
          }
        `
      ],
      subtitle: [
        smallStyle.text.subtitle,
        css`
          ${theme.mq.tablet} {
            -webkit-line-clamp: 4;
          }
          ${theme.mq.small_desktop} {
            -webkit-line-clamp: 2;
          }
        `
      ],
      cta: smallStyle.text.cta
    }
  };
};
